import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
  PaginationItem,
  Pagination,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import { get } from "../../utils/api";
import FilterModal from "../../Components/Common/FilterModal";
import AddIcon from "@mui/icons-material/Add";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import RaisedTicket from "./RaisedTicket";
import TicketDetails from "./TicketDetails";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ResolvedTicket from "./ResolvedTicket";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import totalticket from "../../assets/images/totalticket.svg";
import resolvedticket from "../../assets/images/resolvedticket.svg";
import pendingticket from "../../assets/images/pendingticket.svg";
import closedticket from "../../assets/images/closedticket.svg";
import styles from "../../styles/support/ticket.module.css";
import { useUser } from "../../context/AuthContext";
import NoDataFound from "../../Components/Masters/NoDataFound";
import GroupAdminSidebar from "../../Layout/GroupAdminSidebar";
import useAuthStore from "../../store/ContextUser";
const CardsList = ({ data }) => {
  return (
    <div className={styles.cardContainer}>
      <img src={data?.icon} alt="icon" />
      <div className={styles.cardsheader}>
        <p className={styles.cardstitle}>{data?.title ?? "-"}</p>
        <p className={styles.cardsvalue}>{data?.value ?? 0}</p>
      </div>
    </div>
  );
};

const List = () => {
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const [activeTab, setActiveTab] = useState(0);
  const [otherData, setOtherData] = useState([]);
  const [MYTicketData, setMyTicketData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [endDate, setEndDate] = useState(null);
  const [selectedData, setView] = useState({});
  const [resolveDrawerOpen, setResolveDrawerOpen] = useState(false);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterEscalation, setEscalation] = useState([]);
  const [filterStatus, setStatus] = useState([]);
  const [cardData, setCardData] = useState({});
  const [ViewData, setViewData] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    status: [],
    escalationLevel: [],
  });

  const fetchFilters = async () => {
    await get(
      `/support/ticket/filter?ticketType=${
        activeTab === 0 ? "OtherTickets" : "MyTickets"
      }`
    )
      .then((res) => {
        console.log(
          res?.data?.data,
          res?.data?.escalationLevel,
          "sourceFilter"
        );
        setEscalation(res?.data?.data?.escalationLevel);
        setStatus(["Open", "In Progress", "Resolved", "Closed"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, [activeTab]);

  const fetchCardData = async () => {
    try {
      let typeVal = activeTab === 0 ? "Raised" : "Assigned";
      const response = await get(
        `/support/ticket/cardData?ticketType=${typeVal}`
      );
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [activeTab]);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    ...(activeTab === 1
      ? [
          {
            title: "Escalation Level",
            type: "option",
            key: "escalationLevel",
            value: filterEscalation,
          },
        ]
      : []),
    {
      title: "Status",
      type: "option",
      key: "status",
      value: filterStatus,
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async (type, filterOverride, pageOverride) => {
    setIsLoading(true);
    let filter = filterOverride || { ...filterObj };
    let currentPage = pageOverride || page;

    if (filter.createdAt?.start) {
      filter.startDate = filter.createdAt.start;
    }
    if (filter.createdAt?.end) {
      filter.endDate = filter.createdAt.end;
    }
    try {
      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        ticketType: type === "Tickets Raised" ? "Raised" : "Assigned",
      }).toString();
      const response = await get(`/support/ticket/get?${queryParams}`);
      type === "Tickets Raised"
        ? setOtherData(response.data.data || [])
        : setMyTicketData(response.data.data || []);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab === 0 ? "Tickets Raised" : "Tickets Assigned", null, 1);
  }, [activeTab]);

  useEffect(() => {
    fetchData(
      activeTab === 0 ? "Tickets Raised" : "Tickets Assigned",
      null,
      page
    );
  }, [page]);

  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setPage(1); // Reset to first page on filter change
    // Check if newFilterObj has any non-empty values
    const hasFilters = Object.values(newFilterObj).some((val) =>
      Array.isArray(val) ? val.length > 0 : val && String(val).trim() !== ""
    );
    setIsFiltersApplied(hasFilters);
    fetchData(
      activeTab === 0 ? "Tickets Raised" : "Tickets Assigned",
      newFilterObj,
      1
    );
  };

  console.log("first2", filterObj);

  const handleAdd = (i) => {
    setIsDrawerOpen(true);
    setIndex(i);
  };

  // Fetch data whenever activeTab changes
  useEffect(() => {
    const type = activeTab === 0 ? "Tickets Raised" : "Tickets Assigned";
    fetchData(type);
  }, [activeTab]);

  const tableData = activeTab === 0 ? otherData : MYTicketData;

  const tabStyles = (isActive) => ({
    borderRadius: "6px",
    textTransform: "none",
    backgroundColor: isActive ? "#1C486B" : "transparent",
    color: isActive ? "white" : "#1C486B",
    borderColor: "#1C486B",
    "&:hover": {
      backgroundColor: isActive ? "#1C486B" : "rgba(24, 77, 128, 0.1)",
      borderColor: "#1C486B",
    },
  });

  const inputData = [
    {
      fieldName: "title",
      title: "Title",
      placeholder: "Enter Title",
      type: "text",
    },
    {
      fieldName: "raisedAgainst",
      title: "Raised Against",
      type: "select",
      option: ["Vajra Support", "Internal Support"],
    },
    {
      fieldName: "assignedTo",
      title: "Assigned To",
      type: "dependToraisedAgainst",
      url: `/support/ticket/get/users`,
    },
    {
      fieldName: "description",
      title: "Description",
      placeholder: "Brief",
      type: "multiline",
    },
    {
      fieldName: "documents",
      title: "Upload Document",
      type: "file",
    },
  ];

  const resolveData = [
    {
      fieldName: "status",
      title: "Ticket Status",
      option: ["Open", "In Progress", "Resolved", "Closed"],
      type: "select",
    },
    {
      fieldName: "resolvedRemark",
      title: "Resolve Remark",
      placeholder: "Enter Remark",
      type: "multiline",
    },
    {
      fieldName: "documents",
      title: "Upload Document",
      type: "file",
    },
  ];

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  console.log("first2", otherData, MYTicketData);

  const handleResolve = (i) => {
    setResolveDrawerOpen(true);
    setViewData(i);
  };

  const handleView = (view) => {
    setView(view);
    setIsViewOpen(true);
  };

  let bannerData = [
    {
      title: "Total Tickets",
      multiple: true,
      icon: totalticket,
      value: cardData?.totalTickets || 0,
      multipleValues: ["Total Tickets", `${cardData?.totalTickets || 0} `],
    },
    {
      title: "Pending Tickets",
      multiple: true,
      icon: pendingticket,
      value: cardData?.pending || 0,
      multipleValues: ["Pending Tickets", `${cardData?.pending || 0} `],
    },
    {
      title: "Resolved Tickets",
      multiple: true,
      icon: resolvedticket,
      value: cardData?.resolved || 0,
      multipleValues: ["Resolved Tickets", `${cardData?.resolved || 0} `],
    },
    {
      title: "Closed",
      multiple: true,
      icon: closedticket,
      value: cardData?.closed || 0,
      multipleValues: ["Closed", `${cardData?.closed || 0} `],
      // description: `${cardData?.closed|| 0} `,
    },
  ];

  const columnWidths = ["10%", "25%", "15%", "10%", "15%", "15%", "10%"];

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      {/* <Unauthorized requiredModule="Setup"> */}
      <>
        <RaisedTicket
          inputData={inputData}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          setsnackOpen={setsnackOpen}
          fetchData={() => fetchData("Tickets Raised")}
          fetchCardData={fetchCardData}
        />
        <TicketDetails
          setIsViewOpen={setIsViewOpen}
          isViewOpen={isViewOpen}
          selectedData={selectedData}
          setView={setView}
        />
        <ResolvedTicket
          inputData={resolveData}
          isDrawerOpen={resolveDrawerOpen}
          ViewData={ViewData}
          setIsDrawerOpen={setResolveDrawerOpen}
          setsnackOpen={setsnackOpen}
          fetchData={() => fetchData("Tickets Assigned")}
          fetchCardData={fetchCardData}
        />
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={filterData}
          onFilterChange={handleFilterChange}
          title="Filter"
        />
        <Snackbar
          open={snackOpen.open}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>

        <Box sx={{ paddingTop: "20px", width: "100%", marginBottom: "1.5rem" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Support
          </Typography>
          <div className={styles.cards}>
            {bannerData &&
              bannerData?.length > 0 &&
              bannerData?.map((item) => <CardsList data={item} />)}
            {/* <Cards flexwrap="no" data={bannerData} /> */}
          </div>

          <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                width: "fit-content",
                gap: "30px",
              }}
            >
              {["Tickets Raised", "Tickets Assigned"].map((label, index) => (
                <Button
                  key={label}
                  onClick={() => setActiveTab(index)}
                  variant={activeTab === index ? "contained" : "outlined"}
                  sx={tabStyles(activeTab === index)}
                >
                  {label}
                </Button>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "fit-content",
                gap: "30px",
              }}
            >
              <Button
                variant="contained"
                onClick={() => setIsFilterModalOpen(true)}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF",
                  },
                }}
              >
                Filter
                <FilterListIcon />
                {isFiltersApplied && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "14px",
                  textTransform: "none",
                }}
                endIcon={<AddIcon />}
                onClick={() => handleAdd(0)}
              >
                Raise Ticket
              </Button>
            </Box>
          </Box>

          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      colSpan={8}
                      sx={{
                        borderBottom: "1px solid #E0E0E0",
                        padding: "12px",
                        fontSize: "16px",
                        fontFamily: "Inter",
                        fontWeight: "600",
                        color: "rgba(34, 34, 34, 1)",
                      }}
                    >
                      Tickets
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {[
                      "Ticket ID",
                      "Title",
                      "Escalation Level",
                      "Status",
                      "Create Date",
                      "Resolution Time",
                      "Action",
                    ].map((header, idx) => (
                      <TableCell
                        key={header}
                        align="left"
                        sx={{
                          padding: "12px",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          fontWeight: "600",
                          width: columnWidths[idx],
                          whiteSpace: "nowrap",
                          fontFamily: "Inter",
                          fontSize: "16px",
                          color: "rgba(34, 34, 34, 1)",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.length > 0 ? (
                    tableData.map((row, index) => (
                      <TableRow
                        key={row._id}
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "rgba(34, 34, 34, 1)",
                          "& td": {
                            borderRight: "1px solid #E0E0E0",
                            verticalAlign: "middle",
                            padding:
                              activeTab === 1
                                ? row?.status === "Open"
                                  ? "4px 12px"
                                  : "12px"
                                : "8px 12px",
                          },
                          "&:last-child td": { borderBottom: "none" },
                        }}
                      >
                        <TableCell align="center" sx={{ fontSize: "14px" }}>
                          {row.ticketNumber}
                        </TableCell>
                        <TableCell align="left" sx={{ fontSize: "14px" }}>
                          {row.title}
                        </TableCell>
                        <TableCell align="left" sx={{ fontSize: "14px" }}>
                          {row.escalationLevel}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: "14px",
                            color:
                              row.status === "Open"
                                ? "rgba(255, 187, 51, 1)"
                                : row.status === "Closed"
                                ? "rgba(255, 68, 68, 1)"
                                : "rgba(0, 200, 81, 1)",
                          }}
                        >
                          {row.status}
                        </TableCell>
                        <TableCell align="left" sx={{ fontSize: "14px" }}>
                          {new Date(row.createdAt).toLocaleDateString()}
                        </TableCell>
                        <TableCell align="left" sx={{ fontSize: "14px" }}>
                          {row.timeElapsed}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: "14px",
                            color: "#007BFF", // Anchor text color (blue in this example)
                            textDecoration: "none", // Removes underline
                            cursor: "pointer",
                          }}
                          // onClick={() =>
                          //   activeTab === 0
                          //     ? handleView(row)
                          //     : handleResolve(row)
                          // }
                        >
                          {activeTab === 0 ? (
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#0a3f73",
                                textTransform: "none",
                                padding: "4px",
                              }}
                              onClick={() => handleView(row)}
                            >
                              View
                            </Button>
                          ) : (
                            <>
                              {row?.status !== "Resolved" &&
                              row?.status !== "Closed" ? (
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#0a3f73",
                                    textTransform: "none",
                                  }}
                                  onClick={() => handleResolve(row)}
                                >
                                  Resolve
                                </Button>
                              ) : null}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        align="center"
                        sx={{ height: "200px", verticalAlign: "middle" }}
                      >
                        <NoDataFound />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 3,
                backgroundColor: "#ffffff",
                width: "100%",
                borderRadius: "2%",
                padding: "4px",
                marginBottom: "1rem",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                renderItem={(item) => (
                  <StyledPaginationItem
                    // <PaginationItem
                    {...item}
                    components={{
                      previous: () => (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mr: 27,
                          }}
                        >
                          <ArrowBackIcon sx={{ mr: 0.5, color: "green" }} />
                          Previous
                        </Box>
                      ),
                      next: () => (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            ml: 27,
                          }}
                        >
                          Next
                          <ArrowForwardIcon sx={{ ml: 0.5, color: "green" }} />
                        </Box>
                      ),
                    }}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        mx: 1,
                      },
                      "& .MuiPagination-ul": {
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                )}
              />
            </Box>
          )}
        </Box>
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default List;
